import React from "react";
import styled from "styled-components";

const UniqueContainer = styled.section`
    width: 100%;
    padding: 60px 20px;
    background: #ffe5e5;
    box-sizing: border-box;
`;

const UniqueTitle = styled.h2`
    text-align: center;
    font-size: 30px;
    margin-bottom: 50px;
    color: #d70000;
    font-weight: bold;
`;

const UniqueGrid = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    justify-content: center;
`;

const UniqueCard = styled.div`
    background-color: #fff0f0;
    border-radius: 10px;
    overflow: hidden;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    max-width: 300px;
    flex: 1;
    min-width: 240px;
    transition: transform 0.3s ease, box-shadow 0.3s ease;

    &:hover {
        transform: translateY(-6px);
        box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
    }
`;

const UniqueImage = styled.img`
    width: 100%;
    height: 180px;
    object-fit: cover;
`;

const UniqueContent = styled.div`
    padding: 15px;
`;

const UniqueCardTitle = styled.h3`
    font-size: 20px;
    margin-bottom: 10px;
    color: #d70000;
`;

const UniqueCardDescription = styled.p`
    font-size: 14px;
    color: #5a5a5a;
    line-height: 1.3;
`;

const portfolioData = [
  {
    image: "port1.jpg",
    title: "Künstliche Intelligenz Lösungen",
    description:
      "Wir entwickeln innovative KI-Lösungen, um Prozesse zu optimieren und die Produktivität in verschiedenen Bereichen zu steigern."
  },
  {
    image: "port2.jpg",
    title: "Benutzererfahrung",
    description:
      "Wir schaffen digitale Plattformen, die auf Benutzererfahrung fokussiert sind, und kombinieren Technologie mit Strategie, um Mehrwert zu schaffen."
  },
  {
    image: "port3.jpg",
    title: "Erweiterte Anpassung",
    description:
      "Wir implementieren maßgeschneiderte Lösungen, um die einzigartigen Bedürfnisse jedes Kunden zu erfüllen und dessen Wettbewerbsfähigkeit zu steigern."
  },
  {
    image: "port4.jpg",
    title: "Innovative Strategien",
    description:
      "Wir entwerfen und führen disruptive digitale Strategien aus, die das Unternehmenswachstum und die Transformation vorantreiben."
  }
];

const UniqueComponent = () => {
  return (
    <UniqueContainer>
      <UniqueTitle>Unsere Exklusiven Angebote</UniqueTitle>
      <UniqueGrid>
        {portfolioData.map((item, index) => (
          <UniqueCard key={index}>
            <UniqueImage src={item.image} alt={item.title} />
            <UniqueContent>
              <UniqueCardTitle>{item.title}</UniqueCardTitle>
              <UniqueCardDescription>{item.description}</UniqueCardDescription>
            </UniqueContent>
          </UniqueCard>
        ))}
      </UniqueGrid>
    </UniqueContainer>
  );
};

export default UniqueComponent;